module.exports = __webpack_public_path__ + "img/08.322c15dd.png";